/**
 * Edition flag — SaaS vs. enterprise on-prem builds.
 *
 * Set REACT_APP_EDITION=enterprise at build time (see `npm run build:enterprise`)
 * for on-prem customer bundles. Anything else (including unset) is the multi-tenant
 * SaaS edition, so existing builds are unaffected.
 *
 * In enterprise builds the platform super-admin (`/sa`) control plane is excluded:
 * the route subtree is gated by `isEnterprise` here, and config-overrides.js aliases
 * the SuperAdminRoutes module to an empty stub so its code never ships.
 */
export const EDITION = (process.env.REACT_APP_EDITION || 'saas').toLowerCase();

// NOTE: compared against process.env directly (not the normalized EDITION) so the
// production minifier can fold it to a literal and dead-code-eliminate gated blocks
// (e.g. the SaaS nav in Sidebar.js). The build flag is always lowercase 'enterprise'
// (set by `npm run build:enterprise`).
export const isEnterprise = process.env.REACT_APP_EDITION === 'enterprise';
